// extracted by mini-css-extract-plugin
export var wagonNumberLink = "e55acc120b4e3eac14e44c14f3badb68-css";
export var popover = "a089230b5922181d2df2af553f952446-css";
export var cellCenterContainer = "_0f1961c8d6718c3254d9b0066dc156ef-css";